import { AnimatedComponent } from 'sane-ui'

class Separator extends AnimatedComponent {
  constructor ($el, args) {
    args.offset = '95%'
    super($el, args)
  }

  buildTimelineIn () {
    const $hr = this.$el.find('hr')

    this.timelineIn
      .set(this.$el, { autoAlpha: 1 })
      .from($hr, { duration: 0.6, opacity: 0, ease: 'none' }, 0)
      .from($hr, { duration: 0.6, scaleX: 0, ease: 'power2.out' }, 0)
  }
}

export default Separator



// WEBPACK FOOTER //
// ./scripts/components/Separator.js